import React from 'react';
import { Link } from 'react-router-dom';
import Section from '../Section';
import Breadcrumb from '../Breadcrumb';
import BannerSectionStyle9 from '../Section/BannerSection/BannerSectionStyle9';
import { Icon } from '@iconify/react';
import Spacing from '../Spacing';
import Post from '../Post';
import Sidebar from '../Sidebar';
import AuthorWidget from '../Widget/AuthorWidget';
import CommentsWidget from '../Widget/CommentsWidget';
import ReplyWidget from '../Widget/ReplyWidget';
import { pageTitle } from '../../helpers/PageTitle';
const tags = [
  { tag: 'Emergency', href: '/blog/blog-details' },
  { tag: 'Pediatric', href: '/blog/blog-details' },
  { tag: 'Cardiology', href: '/blog/blog-details' },
  { tag: 'Psychiatry', href: '/blog/blog-details' },
  { tag: 'Others', href: '/blog/blog-details' },
];
const relatedBlog = [
  {
    title:
      'The Importance of Mental Health: Understanding and Managing Anxiety Disorders',
    thumbUrl: '/images/blog/post_1.jpeg',
    date: 'March 12',
    btnText: 'Learn More',
    href: '/blog/blog-details',
  },
  {
    title: `A Parent's Guide to Childhood Vaccinations: What You Need to Know`,
    thumbUrl: '/images/blog/post_2.jpeg',
    date: 'March 11',
    btnText: 'Learn More',
    href: '/blog/blog-details',
  },
  {
    title: 'Preventing Heart Disease: Tips for a Heart-Healthy Lifestyle',
    thumbUrl: '/images/blog/post_3.jpeg',
    date: 'March 9',
    btnText: 'Learn More',
    href: '/blog/blog-details',
  },
];

export default function BlogDetails() {
  pageTitle('Blog Details');
  return (
    <>
      <Section topMd={170} bottomMd={54} bottomLg={54}>
        <Breadcrumb />
      </Section>
      <div className="container">
        <div className="cs_blog_details_info">
          <div className="cs_blog_details_info_left">
            {/* <div className="cs_blog_details_tags">
              {tags.map((item, index) => (
                <Link key={index} to={item.href}>
                  {item.tag}
                </Link>
              ))}
            </div> */}
            <div className="cs_blog_details_date">
              March 12, 2023
            </div>
          </div>
          {/* <div className="cs_social_links_wrap">
            <h2>Share:</h2>
            <div className="cs_social_links">
              <Link to="/">
                <Icon icon="fa-brands:facebook-f" />
              </Link>
              <Link to="/">
                <Icon icon="fa-brands:linkedin-in" />
              </Link>
              <Link to="/">
                <Icon icon="fa-brands:twitter" />
              </Link>
            </div>
          </div> */}
        </div>
        <Spacing md="" />
        <img
          src="/images/home_1/pro1.jpeg"
          alt="Blog Details"
          className="w-100 cs_radius_20"
        />
        <Spacing md="" lg="50" />
        <div className="row">
          <div className="col-lg-8">
            <div className="cs_blog_details">
              <h2>SAM ROSE</h2>
              <p>
                This medication is an iron supplement used to treat or prevent low
                during pregnancy). Ascorbic acid (vitamin C
                product contains a mineral (iron) along with
                these nutrients which may occur in certain health conditions (such as
                is an important mineral that the body needs to produce red
                the stomach. Folic acid is needed to form healthy cells, especially red blood cells.Women of childbearing age should
                maintain adequate amounts of folic acid either through diet or
                Symptoms of iron deficiency <br />
                <br />
                The most common signs of deficiency include:              </p>
              <ol>
                <li>
                  <b>pale skin</b>
                  <br />
                  
                </li>
                <li>
                  <b>depression</b> <br />
                 
                </li>
                <li>
                  <b>fatigue</b>
                  <br />
                  
                </li>
                <li>
                  <b>weakness</b>
                  <br />
                 
                </li>
                <li>
                  <b>puffiness in the face and under the eyes</b> <br />
                 
                </li>
                <li>
                  <b>dizziness</b> <br />
                 
                </li>
              </ol>
              <h2>SAMROSE TAB LITERATURE</h2>

              <p>
              Vitamin C
It is a strong antioxidant that can boost your blood antioxidant levels. This may help reduce the risk of chronic
diseases like heart disease.
Vitamin C supplements have been found to lower blood pressure in both healthy adults and those with high blood
pressure.
Vitamin C can improve the absorption of iron that is poorly absorbed, such as iron from meat-free sources. It may
also reduce the risk of iron deficiency.
Vitamin C may boost immunity by helping white blood cells function more effectively, strengthening your skin’s
defense system, and helping wounds heal faster.
                <br />
               
              </p>
              {/* <blockquote
                style={{
                  backgroundImage: 'url("/images/blog/blog_details_2.jpeg")',
                }}
              >
                <p>
                  “Treatment for these disorders do exist and often involve a
                  combination of psychotherapy, behavioral therapy, and
                  medication.”
                </p>
              </blockquote> */}
              {/* <h2>
                How to Manage Anxiety Disorders: Techniques and Strategies
              </h2>
              <p>
                Anxiety disorders can be overwhelming and interfere with daily
                life, but there are ways to manage these feelings. From
                self-care strategies to professional help, below are methods to
                effectively cope with anxiety disorders.
              </p>
              <ul>
                <li>
                  <h3>1. Professional Treatment</h3>
                  If you are dealing with an anxiety disorder, seeking
                  professional help is crucial. Mental health professionals can
                  provide a diagnosis and suggest appropriate treatment options.
                  These typically include:
                </li>
                <li>
                  <h3>2. Self-Care Techniques</h3>
                  In addition to professional treatment, there are several
                  self-care strategies that you can adopt to help manage
                  anxiety: <br />
                  <br />
                  <b>Mindful meditation and relaxation techniques:</b> Deep
                  breathing exercises, progressive muscle relaxation, and
                  mindfulness meditation can reduce symptoms of anxiety by
                  promoting relaxation and reducing feelings of fear and worry.{' '}
                  <br />
                  <br />
                  <b>Healthy lifestyle:</b> Regular physical exercise, a healthy
                  diet, adequate sleep, and reducing caffeine and alcohol can
                  also help manage anxiety symptoms. <br />
                  <br />
                  <b>Maintaining a positive outlook:</b> While it may seem
                  challenging, it's beneficial to focus on positive aspects of
                  your life. Gratitude exercises or maintaining a journal to
                  record positive experiences can assist in cultivating an
                  optimistic outlook. <br />
                  <br />
                  <b>Avoiding avoidance:</b> It's common for people with anxiety
                  to avoid situations or objects that trigger their anxiety.
                  However, avoiding these triggers can reinforce the fear. Safe
                  exposure to these triggers under the guidance of a therapist
                  can help in managing and eventually reducing anxiety.
                </li>
                <li>
                  <h3>3. Utilizing Technology</h3>
                  There are numerous digital health platforms, such as
                  smartphone apps and online counseling services, that can help
                  manage anxiety disorders. These platforms can provide
                  cognitive-behavioral therapy, mindfulness training, and other
                  helpful resources.
                </li>
              </ul>
              <h2>Conclusion</h2>
              <p>
                Anxiety disorders can be daunting, but with the right
                combination of professional help and personal coping strategies,
                they can be managed effectively. It's essential to remember that
                help is available and that you're not alone in your struggle.{' '}
                <br />
                <br />
                Remember, it's crucial to reach out to a mental health
                professional if you're experiencing symptoms of an anxiety
                disorder. What works best will depend on the individual and the
                type of anxiety disorder, and it's essential to get a
                professional's guidance for effective management.
              </p> */}
            </div>
            {/* <Spacing md="85" /> */}
          
            {/* <Spacing md="110" /> */}
            {/* <CommentsWidget title="Comments" /> */}
            <Spacing md="92" />
            <ReplyWidget  />
          </div>
          <div className="col-lg-4">
            <Sidebar />
          </div>
        </div>
        <Spacing md="135" lg="100" />
       
      </div>
      <Spacing md="200" xl="150" lg="110" />
      {/* <Section className="cs_footer_margin_0">
        <BannerSectionStyle9
          title="Don’t Let Your Health <br />Take a Backseat!"
          subTitle="Schedule an appointment with one of our experienced <br />medical professionals today!"
          imgUrl="/images/doctors/banner_img_3.png"
        />
      </Section> */}
    </>
  );
}
